export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00875.6aa5758d.png";